module.exports = __webpack_public_path__ + "img/icon-exit.d861358c.png";